import { render, staticRenderFns } from "./AddAttributes.vue?vue&type=template&id=9f1522f2"
import script from "./AddAttributes.vue?vue&type=script&lang=js"
export * from "./AddAttributes.vue?vue&type=script&lang=js"
import style0 from "./AddAttributes.vue?vue&type=style&index=0&id=9f1522f2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f1522f2')) {
      api.createRecord('9f1522f2', component.options)
    } else {
      api.reload('9f1522f2', component.options)
    }
    module.hot.accept("./AddAttributes.vue?vue&type=template&id=9f1522f2", function () {
      api.rerender('9f1522f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/AddAttributes.vue"
export default component.exports